<template lang="html">

  <section class="ficha -practica">

    <template v-if="!!data">
      <div class="contenedor-opciones row-between">
        <h2 class="ficha-title" :style="styles.colorBasic">Candidatos</h2>
        <div class="row-end" v-if="!!data.candidatos && data.candidatos.length > 0">
          <a class="option-table column-center">
            <i class="row-between ais" @click="exportExcel">
              <excel></excel>
            </i>
          </a>
        </div>
      </div>
      
      <article class="group">
        <div class="contenedor-data -full" v-if="!!data.candidatos && data.candidatos.length > 0">
            <p v-for="candidato in data.candidatos" class="w-100 contact-section"><span class="negrita">{{ candidato.nombreCompleto }}</span>  - {{candidato.titulacion}} - {{candidato.estadoCandidatura}}</p>
          </div>
          <div v-else>
            <p>Sin candidatos</p>
          </div>     
      </article>
    </template>
   
  </section>

</template>

<script lang="js">
  import {
    mapGetters,
    mapActions
  } from 'vuex';

  import onlyArrow from '@/components/parts/icons/only-arrow';
  import arrowlink from '@/components/parts/icons/arrow-link';
  import excel from '@/components/parts/icons/excel';
  import XLSX from 'xlsx';
  import addDocumentacion from '@/components/parts/add-documentacion';

  export default {
    name: 'ficha-practica',
    props: ['data'],
    data() {
      return {
        showadddocumentacion: false,
        uploadtype: '',
        documentacionPendiente: []
      }
    },
    mounted() {

    },
    methods: {
      exportExcel() {

      let data = XLSX.utils.json_to_sheet(this.data.candidatos);
      const workbook = XLSX.utils.book_new();
      
      const filename = String(`Candidatos Oferta ` + this.data.idOferta);
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },

    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        documentos: 'getDocumentos',
        uploaddoc: 'getCanUploadDocPracticas',
        brand: 'getBrand'
      }),

    },
    components: {
      'only-arrow': onlyArrow,
      'arrow-link': arrowlink,
      'add-documentacion': addDocumentacion,
      'excel': excel
    }

  }
</script>

<style scoped lang="scss">
 .contact-section{
  display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #dedede;
    margin-bottom: 15px;
    padding-bottom: 15px;
 }

 .contenedor-opciones {
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

.option-table {
  text-transform: uppercase;
  font-size: 9px;
  text-align: center;
  padding: 0 10px;
  position: relative;
}

svg {
    width: 30px;
    height: 30px;
  }

  .ficha-title {
  margin-top: 0;
  margin-bottom: 0;
  width: auto;
}

.negrita{
	font-weight: bold;
	display: contents;
}
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-candidatos.vue